<template>
  <!-- Use el-tag for standard colors -->
  <el-tag v-if="isStandardColor" :type="elementUiType" :size="size">
    <slot></slot>
  </el-tag>

  <!-- Use custom styled span for custom colors -->
  <span v-else :class="['custom-color-tag', sizeClass]" :style="tagStyle">
    <slot></slot>
  </span>
</template>

<script>
import Color from "color";

export default {
  name: "CustomColorTag",
  props: {
    color: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: "mini",
      validator: (value) => ["mini", "small", "medium"].includes(value),
    },
  },
  computed: {
    // Check if color is a standard Element UI color
    isStandardColor() {
      if (!this.color) return false;
      const standardColors = ["red", "green", "blue", "yellow"];
      return standardColors.includes(this.color.toLowerCase());
    },

    // Map standard colors to Element UI tag types
    elementUiType() {
      const colorTypeMap = {
        green: "success",
        red: "danger",
        yellow: "warning",
        blue: "primary",
      };
      return colorTypeMap[this.color.toLowerCase()] || "";
    },

    sizeClass() {
      return `custom-color-tag--${this.size}`;
    },
    tagStyle() {
      if (!this.color) {
        // Fallback to default gray styling
        return {
          backgroundColor: "#f4f4f5",
          borderColor: "#e9e9eb",
          color: "#909399",
        };
      }

      try {
        const baseColor = Color(this.color);

        return {
          backgroundColor: baseColor.alpha(0.1).string(),
          borderColor: baseColor.alpha(0.1).string(),
          color: baseColor.string(),
        };
      } catch (error) {
        // If color parsing fails, use fallback
        return {
          backgroundColor: "#f4f4f5",
          borderColor: "#e9e9eb",
          color: "#909399",
        };
      }
    },
  },
};
</script>

<style scoped lang="scss">
.custom-color-tag {
  display: inline-block;
  padding: 0 8px;
  line-height: 20px;
  font-size: 12px;
  border: 1px solid;
  border-radius: 4px;
  box-sizing: border-box;
  white-space: nowrap;
  font-weight: 500;
}

.custom-color-tag--mini {
  height: 20px;
  padding: 0 5px;
  line-height: 18px;
  font-size: 12px;
}

.custom-color-tag--small {
  height: 24px;
  padding: 0 8px;
  line-height: 22px;
  font-size: 12px;
}

.custom-color-tag--medium {
  height: 28px;
  padding: 0 10px;
  line-height: 26px;
  font-size: 14px;
}
</style>
